import React from 'react';
import Select from "react-dropdown-select";

import * as  constants from '../../constants/constants';
import styles from './dropdown.module.css';

const dropdown = ({ handleChangeState, selectedData }) => {
    const states = constants.constantsVariables.state;

    return (
        <div className={styles.formControl}>
            <div>Select State:</div>
            <Select
                placeholder="Search with state"
                onChange={(e) => handleChangeState(e)}
                labelField='name'
                valueField='value'
                direction="auto"
                options={states}
                values={[selectedData]}
                color='#7ed6df'
                closeOnSelect={true} />
        </div>
    );
};

export default dropdown;